import ListPage, { useList } from '@/components/BaseList';
import { usePermission } from '@/common/hooks/index';
import { httpPageOdsNationalSupplyDrug } from '@/services/datamanagement';
import React from 'react';
import SearchForm from './components/SearchForm';
import styles from './index.less';

/**
 * 国家药品供应保障综合管理信息平台药品目录
 * @returns
 */
const DrugCatalog: React.FC = () => {
  const { permission } = usePermission();

  const list = useList();
  const fetchAPi = (params: any) => {
    const req: any = {
      // ...params,
      limit: params.pageSize,
      pageNo: params.current,
      cond: {
        name: params.name,
        company: params.company,
        approvalNumber: params.approvalNumber,
      },
      // orders: [
      //   {
      //     direction: params.direction === 'ascend' ? 'ASC' : 'DESC',
      //     property: params.property || 'createTime',
      //   },
      // ],
    };

    return httpPageOdsNationalSupplyDrug(req).then((res) => {
      return {
        listData: res.data,
        pagination: {
          current: res.pageIndex,
          pageSize: res.pageSize,
          total: res.totalCount,
        },
      };
    });
  };

  const changetable = (pagination: any, filters: any, sorter: any) => {
    const property: string = sorter.columnKey;
    list.current.fetchListData({ direction: sorter.order, property });
  };

  const columns = [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      width: 100,
      children: [
        {
          title: 'id',
          dataIndex: 'id',
          key: 'id',
          width: 100,
        },
      ],
    },
    {
      title: 'YPID',
      dataIndex: 'YPID',
      key: 'YPID',
      children: [
        {
          title: 'ypid',
          dataIndex: 'ypid',
          key: 'ypid',
        },
      ],
    },
    {
      title: '产品名称',
      dataIndex: 'name',
      key: 'name',
      children: [
        {
          title: 'name',
          dataIndex: 'name',
          key: 'name',
        },
      ],
    },
    {
      title: '生产企业名称',
      dataIndex: 'company',
      key: 'company',
      children: [
        {
          title: 'company',
          dataIndex: 'company',
          key: 'company',
        },
      ],
    },
    {
      title: '企业编码',
      dataIndex: 'companyCode',
      key: 'companyCode',
      children: [
        {
          title: 'companyCode',
          dataIndex: 'companyCode',
          key: 'companyCode',
        },
      ],
    },
    {
      title: '批准文号',
      dataIndex: 'approvalNumber',
      key: 'approvalNumber',
      children: [
        {
          title: 'approvalNumber',
          dataIndex: 'approvalNumber',
          key: 'approvalNumber',
        },
      ],
    },
    {
      title: '大类',
      dataIndex: 'category',
      key: 'category',
      children: [
        {
          title: 'category',
          dataIndex: 'category',
          key: 'category',
        },
      ],
    },
    {
      title: '大类码',
      dataIndex: 'categoryCode',
      key: 'categoryCode',
      children: [
        {
          title: 'categoryCode',
          dataIndex: 'categoryCode',
          key: 'categoryCode',
        },
      ],
    },
    {
      title: '药理/功效分类',
      dataIndex: 'effect',
      key: 'effect',
      children: [
        {
          title: 'effect',
          dataIndex: 'effect',
          key: 'effect',
        },
      ],
    },
    {
      title: '药理/功效分类码',
      dataIndex: 'effectCode',
      key: 'effectCode',
      children: [
        {
          title: 'effectCode',
          dataIndex: 'effectCode',
          key: 'effectCode',
        },
      ],
    },
    {
      title: '品种名（中文）',
      dataIndex: 'productName',
      key: 'productName',
      children: [
        {
          title: 'productName',
          dataIndex: 'productName',
          key: 'productName',
        },
      ],
    },
    {
      title: '品种名（英文）',
      dataIndex: 'productEnName',
      key: 'productEnName',
      children: [
        {
          title: 'productEnName',
          dataIndex: 'productEnName',
          key: 'productEnName',
        },
      ],
    },
    {
      title: '品种名代码',
      dataIndex: 'productCode',
      key: 'productCode',
      children: [
        {
          title: 'productCode',
          dataIndex: 'productCode',
          key: 'productCode',
        },
      ],
    },
    {
      title: '酸根盐基',
      dataIndex: 'acid',
      key: 'acid',
      children: [
        {
          title: 'acid',
          dataIndex: 'acid',
          key: 'acid',
        },
      ],
    },
    {
      title: '酸根盐基分类码',
      dataIndex: 'acidCode',
      key: 'acidCode',
      children: [
        {
          title: 'acidCode',
          dataIndex: 'acidCode',
          key: 'acidCode',
        },
      ],
    },
    {
      title: '剂型分类名称',
      dataIndex: 'dosage',
      key: 'dosage',
      children: [
        {
          title: 'dosage',
          dataIndex: 'dosage',
          key: 'dosage',
        },
      ],
    },
    {
      title: '剂型分类码',
      dataIndex: 'dosageCode',
      key: 'dosageCode',
      children: [
        {
          title: 'dosageCode',
          dataIndex: 'dosageCode',
          key: 'dosageCode',
        },
      ],
    },
    {
      title: '规格',
      dataIndex: 'spec',
      key: 'spec',
      children: [
        {
          title: 'spec',
          dataIndex: 'spec',
          key: 'spec',
        },
      ],
    },
    {
      title: '制剂规格分类码',
      dataIndex: 'specCode',
      key: 'specCode',
      children: [
        {
          title: 'specCode',
          dataIndex: 'specCode',
          key: 'specCode',
        },
      ],
    },
    {
      title: '转换系数',
      dataIndex: 'conversionNum',
      key: 'conversionNum',
      children: [
        {
          title: 'conversionNum',
          dataIndex: 'conversionNum',
          key: 'conversionNum',
        },
      ],
    },
    {
      title: '转换系数编码',
      dataIndex: 'conversionNumCode',
      key: 'conversionNumCode',
      children: [
        {
          title: 'conversionNumCode',
          dataIndex: 'conversionNumCode',
          key: 'conversionNumCode',
        },
      ],
    },
    {
      title: '材质包装',
      dataIndex: 'material',
      key: 'material',
      children: [
        {
          title: 'material',
          dataIndex: 'material',
          key: 'material',
        },
      ],
    },
    {
      title: '最小包装单位',
      dataIndex: 'minPackageUnit',
      key: 'minPackageUnit',
      children: [
        {
          title: 'minPackageUnit',
          dataIndex: 'minPackageUnit',
          key: 'minPackageUnit',
        },
      ],
    },
    {
      title: '最小制剂单位',
      dataIndex: 'minPreparationUnit',
      key: 'minPreparationUnit',
      children: [
        {
          title: 'minPreparationUnit',
          dataIndex: 'minPreparationUnit',
          key: 'minPreparationUnit',
        },
      ],
    },
    {
      title: '差异备注',
      dataIndex: 'diffRemark',
      key: 'diffRemark',
      children: [
        {
          title: 'diffRemark',
          dataIndex: 'diffRemark',
          key: 'diffRemark',
        },
      ],
    },
    {
      title: '原生产企业名称',
      dataIndex: 'sourceCompanyName',
      key: 'sourceCompanyName',
      children: [
        {
          title: 'sourceCompanyName',
          dataIndex: 'sourceCompanyName',
          key: 'sourceCompanyName',
        },
      ],
    },
    {
      title: '原企业编码',
      dataIndex: 'sourceCompanyCode',
      key: 'sourceCompanyCode',
      children: [
        {
          title: 'sourceCompanyCode',
          dataIndex: 'sourceCompanyCode',
          key: 'sourceCompanyCode',
        },
      ],
    },
    {
      title: '原批准文号',
      dataIndex: 'sourceApprovalNumber',
      key: 'sourceApprovalNumber',
      children: [
        {
          title: 'sourceApprovalNumber',
          dataIndex: 'sourceApprovalNumber',
          key: 'sourceApprovalNumber',
        },
      ],
    },
    {
      title: '批准文号开始日期',
      dataIndex: 'approvalNumberBeginDate',
      key: 'approvalNumberBeginDate',
      children: [
        {
          title: 'approvalNumberBeginDate',
          dataIndex: 'approvalNumberBeginDate',
          key: 'approvalNumberBeginDate',
        },
      ],
    },
    {
      title: '批准文号注销日期',
      dataIndex: 'approvalNumberEndDate',
      key: 'approvalNumberEndDate',
      children: [
        {
          title: 'approvalNumberEndDate',
          dataIndex: 'approvalNumberEndDate',
          key: 'approvalNumberEndDate',
        },
      ],
    },
    {
      title: '医保09标识',
      dataIndex: 'medicare09',
      key: 'medicare09',
      children: [
        {
          title: 'medicare09',
          dataIndex: 'medicare09',
          key: 'medicare09',
        },
      ],
    },
    {
      title: '医保17版甲乙类',
      dataIndex: 'medicareCategory17',
      key: 'medicareCategory17',
      children: [
        {
          title: 'medicareCategory17',
          dataIndex: 'medicareCategory17',
          key: 'medicareCategory17',
        },
      ],
    },
    {
      title: '编号',
      dataIndex: 'medicareNo',
      key: 'medicareNo',
      children: [
        {
          title: 'medicareNo',
          dataIndex: 'medicareNo',
          key: 'medicareNo',
        },
      ],
    },
    {
      title: '药品分类',
      dataIndex: 'medicareDrugCategory',
      key: 'medicareDrugCategory',
      children: [
        {
          title: 'medicareDrugCategory',
          dataIndex: 'medicareDrugCategory',
          key: 'medicareDrugCategory',
        },
      ],
    },
    {
      title: '药品分类代码',
      dataIndex: 'medicareDrugCategoryCode',
      key: 'medicareDrugCategoryCode',
      children: [
        {
          title: 'medicareDrugCategoryCode',
          dataIndex: 'medicareDrugCategoryCode',
          key: 'medicareDrugCategoryCode',
        },
      ],
    },
    {
      title: '一级分类',
      dataIndex: 'level1',
      key: 'level1',
      children: [
        {
          title: 'level1',
          dataIndex: 'level1',
          key: 'level1',
        },
      ],
    },
    {
      title: '二级分类',
      dataIndex: 'level2',
      key: 'level2',
      children: [
        {
          title: 'level2',
          dataIndex: 'level2',
          key: 'level2',
        },
      ],
    },
    {
      title: '三级分类',
      dataIndex: 'level3',
      key: 'level3',
      children: [
        {
          title: 'level3',
          dataIndex: 'level3',
          key: 'level3',
        },
      ],
    },
    {
      title: '四级分类',
      dataIndex: 'level4',
      key: 'level4',
      children: [
        {
          title: 'level4',
          dataIndex: 'level4',
          key: 'level4',
        },
      ],
    },
    {
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
      children: [
        {
          title: 'remark',
          dataIndex: 'remark',
          key: 'remark',
        },
      ],
    },
  ];

  return (
    <div className={styles.durg}>
      <ListPage
        list={list}
        fetchApi={fetchAPi}
        columns={columns}
        SearchForm={permission.sysSearchBtn && SearchForm}
        BodyProps={{
          scroll: { x: 6000 },
          onChange: (pagination: any, filters: any, sorter: any) => {
            changetable(pagination, filters, sorter);
          },
        }}
      />
    </div>
  );
};

export default DrugCatalog;
